<template>
	<vue-modal
		:isShowModal="isInfoModal"
		@close="$emit('close')"
		:style="'height: fit-content'"
	>
		<template #header>{{
			props.terms.journal.single === "journal"
				? `${props.terms.journal.single_cap}informationer`
				: `${props.terms.journalCompose.single_cap}informationer`
		}}</template>
		<template #body>
			<VeeForm @submit="onSubmit">
				<Transition name="fade">
					<template v-if="Object.keys(success).length">
						<ul class="form-group alert alert-success">
							<li v-for="(message, key) in success" :key="key">
								{{ message }}
							</li>
						</ul>
					</template>
				</Transition>
				<template v-if="Object.keys(errors).length">
					<ul class="col-md-12 alert alert-danger" id="error_div">
						<li v-for="(message, field) in errors" :key="field">
							{{ message }}
						</li>
					</ul>
				</template>
				<div class="form-body">
					<div
						class="form-group"
						v-if="props.studentOptions.length > 2"
					>
						<Category-Select
							v-if="
								props.studentOptions.some(
									(option) =>
										option.hasOwnProperty('category_id') &&
										option.category_id !== undefined,
								)
							"
							name="student"
							:placeholder="`Vælg ${props.terms?.student?.single}`"
							v-model="student"
							:options="props.studentOptions"
							:selectable="filteredStudents"
							@option:selected="studentSelected"
						></Category-Select>
						<Select
							v-else
							searchable
							name="student"
							:placeholder="`Vælg ${props.terms?.student?.single}`"
							v-model="student"
							:options="props.studentOptions"
							:selectable="filteredStudentsNoDep"
							@option:selected="studentSelected"
						></Select>
					</div>
					<text-editor :message="info"></text-editor>
					<div class="separator form-group" />
					<div
						class="d-flex justify-content-end"
						style="column-gap: 1rem"
					>
						<button type="submit" class="btn btn-primary">
							Gem
						</button>
					</div>
				</div>
			</VeeForm>
		</template>
	</vue-modal>
</template>

<script setup>
import { ref, watch } from "vue";
import vueModal from "@elements/form/vueModal.vue";
import Select from "@elements/select/BaseSingleSelect.vue";
import CategorySelect from "@elements/select/CategorySingleSelect.ce.vue";
import Service from "@services/StudentMetaService";
import { Form as VeeForm, useForm, useField } from "vee-validate";

const service = new Service();

const props = defineProps({
	terms: Object,
	isInfoModal: Boolean,
	studentId: Number,
	studentOptions: Array,
});

const { errors, validate } = useForm();

const { value: student } = useField(
	"student",
	(value) => {
		if (!value || value.option === "") {
			return `Vælg venligst ${props.terms?.student?.single}`;
		}
		return true;
	},
	{
		initialValue: {
			option: "",
			label: `Vælg ${props.terms.student.single}`,
		},
	},
);

const info = ref("");

const success = ref({});

const getStudentInfo = async () => {
	try {
		const response = await service.getBoxData(
			"journal_info",
			student.value.option,
		);
		if (response) {
			info.value = response;
		} else {
			info.value = "";
		}
	} catch (error) {
		console.log(error);
	}
};

watch(
	() => props.studentId,
	(newVal) => {
		if (newVal) {
			const foundStudent = props.studentOptions.filter(
				(option) => option.option === newVal,
			);
			if (foundStudent.length === 1) {
				student.value = props.studentOptions.find(
					(option) => option.option === newVal,
				);
				getStudentInfo();
			}
		}
	},
	{ immediate: true },
);

const studentSelected = (option) => {
	student.value = option;
	getStudentInfo();
};

const onSubmit = async () => {
	const { valid } = await validate();
	if (!valid) {
		return;
	}

	info.value = document
		.querySelector("journal-module")
		.shadowRoot.querySelector("text-editor")
		.shadowRoot.querySelector(".ProseMirror").innerHTML;
	const formData = {
		student_id: student.value.option,
		value: info.value,
	};

	try {
		const response = await service.setMeta("journal_info", formData);
		if (response.status === 200 || response.status === 201) {
			success.value.message = "Informationen er opdateret";
			setTimeout(() => {
				success.value = "";
				emit("close");
				if (props.studentId) location.reload();
			}, "1000");
		}
	} catch (error) {
		console.log(error);
		emit("close");
		if (props.studentId) location.reload();
	}
};

const filteredStudents = (option) => option.option !== "" && !option.isCategory;
const filteredStudentsNoDep = (option) => option.option !== "";

const emit = defineEmits(["close"]);
</script>
